import PropTypes from 'prop-types';
import React from 'react';

export default function List(props) {
	const { wordList, searchTerm, label } = props;
	const classes = ['glossary__list', searchTerm ? 'filtered' : ''];

	// Group the data by the first letter of the word
	const groupByInitial = (list) => {
		const grouped = {};
		Object.entries(list).forEach(([key, value]) => {
			const index = key.charAt(0).toUpperCase();
			if (!grouped[index]) {
				grouped[index] = [];
			}
			grouped[index].push({ key, value });
		});
		return grouped;
	};

	// Transform the data into a list of words with synonyms
	const getWords = () => {
		const sortedKeys = Object.keys(groupByInitial(wordList)).sort();

		return (
			<div className={classes.join(' ')}>
				{sortedKeys.map((index) => (
					<div key={index} className="index index--group">
						<h2 className="index--char">
							<span>{index}</span>
						</h2>
						<div className="index--grid grid--container">
							{groupByInitial(wordList)[index].map(({ key, value }) => (
								<div key={key} className="grid--item">
									<a href={value.url} className="no-link">
										<span className="grid--key">
											<span>{wordList[key].name}</span>
											{wordList[key].synonym ? (
												<>
													<span className="grid--synonym">
														(<span className="icon"></span>
														{wordList[key].synonym} )
													</span>
												</>
											) : (
												<></>
											)}
										</span>
									</a>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		);
	};

	// Filter the transformed data based on the search term
	const getFilteredWords = () => {
		return (
			<div className={classes.join(' ')}>
				<div className="index index--group">
					<h2 className="index--char">
						<span>#</span>
					</h2>
					<div className="index--grid grid--container">
						{Object.keys(wordList).map((key) => (
							<div key={key} className="grid--item">
								<a href={wordList[key].url} className="no-link">
									<span className="grid--key">
										<span>{wordList[key].name}</span>
										{wordList[key].synonym ? (
											<>
												<span className="grid--synonym">
													(<span className="icon"></span>
													{wordList[key].synonym} )
												</span>
											</>
										) : (
											<></>
										)}
									</span>
								</a>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	};

	// Render a message if no results are found
	// TODO: Remove grid and center message
	// TODO: ADD: Search Result List from global Search
	const getNoResultsMessage = () => {
		return (
			<div className={classes.join(' ')}>
				<div className="index index--group">
					<h2 className="index--char">#</h2>
					<div className="grid--container">
						<p className="grid--no-result">{label.no_results}</p>
					</div>
				</div>
			</div>
		);
	};

	// Render the list of words
	return searchTerm ? <>{Object.keys(wordList).length > 0 ? getFilteredWords() : getNoResultsMessage()}</> : <>{getWords()}</>;
}

List.propTypes = {
	wordList: PropTypes.object,
	searchTerm: PropTypes.string,
	label: PropTypes.object,
};
